import { debounce } from './utilities/debounce';

const isHomepage = document.querySelector('.page-home');
const body = document.querySelector('body');
const header = document.querySelector('.header');
const headerLogoContainer = document.querySelector('.header__logo-container');
const headerNavContainer = document.querySelector('.header__nav-container');
const hamburgerContainer = document.querySelector('.header__nav-hamburger-container');
const mobileHamburger = document.querySelector('#mobile-hamburger');
const desktopHamburger = document.querySelector('#desktop-hamburger');
const mobileNav = document.querySelector('.mobile-nav');
const mobileNavContainer = document.querySelector('.mobile-nav__container');
let headerHeight = header.offsetHeight;
let centeringDismissed = false;

const showOrHideHeader = debounce(() => {
    const newUserYPos = window.scrollY;

    // distinct logic for homepage because of centered logo
    if (isHomepage) {
        const BUFFER = 350; // arbitrary value to avoid some visibility of the logo moving left while scrolling down
        const logoCentered = !header.classList.contains('no-centering');

        // deal with logo centering/uncentering
        if (!centeringDismissed) {
            if (newUserYPos > BUFFER && logoCentered) {
                setTimeout(() => {
                    header.classList.add('no-centering');
                }, 300);
            } else if (newUserYPos < headerHeight && !logoCentered) {
                setTimeout(() => {
                    header.classList.remove('no-centering');
                }, 300);
            }
        }
    }
}, 60);

if (isHomepage) {
    addEventListener('scroll', showOrHideHeader);
}

// Click/touch toggle behaviors
const toggleMobileNav = () => {
    const menuExpanded = mobileNav.getAttribute('aria-expanded');
    if (menuExpanded === 'true') {
        closeMobileNav();
    } else {
        openMobileNav();
    }
};

const openMobileNav = () => {
    hamburgerContainer.classList.add('open');
    mobileHamburger.innerText = 'Close Mobile Menu';
    mobileNav.setAttribute('aria-expanded', 'true');
    header.classList.add('header--mobile-nav-open');
    body.setAttribute('style', 'overflow-y: hidden');
};

const closeMobileNav = () => {
    hamburgerContainer.classList.remove('open');
    mobileHamburger.innerText = 'Open Mobile Menu';
    mobileNav.setAttribute('aria-expanded', 'false');
    body.setAttribute('style', 'overflow-y: auto');
    header.classList.remove('header--mobile-nav-open');
    header.classList.add('header--mobile-nav-closing');
    setTimeout(() => {
        header.classList.remove('header--mobile-nav-closing');
        mobileNavContainer.scrollTop = 0;
    }, 300);
};

const toggleDesktopNav = e => {
    const clickedClass = e.target.classList[0];
    if (clickedClass === 'header__nav-submenu-button') {
        const menuExpanded = headerNavContainer.getAttribute('aria-expanded');
        if (menuExpanded === 'true') {
            closeDesktopNav();
        } else {
            openDesktopNav();
        }
    }
};

const openDesktopNav = () => {
    headerNavContainer.setAttribute('aria-expanded', 'true');
    header.classList.add('header--expanded');
};

const closeDesktopNav = () => {
    headerNavContainer.setAttribute('aria-expanded', 'false');
    header.classList.remove('header--expanded');
};

const dismissCentering = () => {
    centeringDismissed = true;
    headerLogoContainer.style.transition = '1s all';
    setTimeout(() => {
        header.classList.add('no-centering');
    }, 300);
};

mobileHamburger.addEventListener('click', toggleMobileNav);
headerNavContainer.addEventListener('click', e => toggleDesktopNav(e));

if (desktopHamburger) {
    desktopHamburger.addEventListener('click', dismissCentering);
}

const handleResize = debounce(() => {
    headerHeight = header.offsetHeight;
    if (window.innerWidth > 900 && mobileNav.getAttribute('aria-expanded') === 'true') {
        closeMobileNav();
    }
    if (
        window.innerWidth < 900 &&
        headerNavContainer.getAttribute('aria-expanded') === 'true'
    ) {
        closeDesktopNav();
    }
}, 200);

// changes the headerHeight variable on window resize
addEventListener('resize', handleResize);
